
import { CButton, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react'
import React, { useRef, useEffect, useState } from 'react'
const Modal = () => {
	const [visible, setVisible] = useState(false)
	const [content, setcontent] = useState(false)
	const [size, setsize] = useState('lg')
	const [title, setTitle] = useState('')
	const actionRef = useRef(null)
	useEffect(() => {
		window.modal = (title, content, size='lg') => {
			setVisible(true)
			setcontent(content)
			setTitle(title)
			setsize(size)
			actionRef.current = null
			return new Promise((resolve, reject)=>{
				actionRef.current = resolve
			})
		}
	}, [])
	return (
		<>
			<CModal container={document.getElementsByClassName('body')[0]}
				title={title}
				visible={visible}
				onClose={() => {
					setVisible(false)
					if(actionRef.current){
						actionRef.current('close')
					}
				}}
				size={size}
			>
				<CModalHeader>
					<CModalTitle>{title}</CModalTitle>
				</CModalHeader>
				<CModalBody>
					<div >{content}</div>
				</CModalBody>
				<CModalFooter>
					<CButton color="primary" onClick={() => {
						setVisible(false)
						if(actionRef.current){
							actionRef.current('close')
						}
					}}>Close</CButton>
					
				</CModalFooter>
			</CModal>
		</>
	)
}

export default Modal